import { createFileRoute } from '@tanstack/react-router';
import { useQuery } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';
import { getHome } from '@mkcore/portal/schema';
import { Card, EmptyState, Skeleton } from '@mkcore/ui';
import { call } from '@/lib/api';
import { formatDate } from '@/lib/format';

export const Route = createFileRoute('/portal/_client/')({
  component: PortalHome,
});

/** The start page of the portal (CO-0661): who you are and what waits for you. */
function PortalHome() {
  const { t } = useTranslation();
  const home = useQuery({ queryKey: ['portal', 'home'], queryFn: () => call(getHome, {}) });
  if (!home.data) return <Skeleton className="h-40" />;
  const { me, todo } = home.data;
  return (
    <>
      <div className="grid gap-1">
        <h1 className="text-2xl font-bold">{t('portal.welcome', { name: me.name.split(' ')[0] })}</h1>
        <p className="text-fg-2">{t('portal.welcomeHint', { organisation: me.organisationName })}</p>
      </div>
      <Card className="grid gap-3 p-4">
        <h2 className="text-lg font-bold">{t('portal.todo')}</h2>
        {todo.length ? (
          <ul className="grid gap-2">
            {todo.map((x) => (
              <li key={`${x.kind}-${x.id}`}>
                <a href={x.path} className="inline-block py-1 font-bold hover:underline">
                  {x.title}
                </a>
                {x.detail && <span className="text-sm text-fg-2"> · {x.detail}</span>}
                {x.dueOn && <span className="text-sm text-fg-2"> · {t(`portal.due.${x.kind}`, { date: formatDate(x.dueOn) })}</span>}
              </li>
            ))}
          </ul>
        ) : (
          <EmptyState title={t('portal.nothingWaits')} />
        )}
      </Card>
      {!me.modules.length && <p className="text-sm text-fg-2">{t('portal.noModulesYet')}</p>}
    </>
  );
}
